import { render, staticRenderFns } from "./BitacoraManager.vue?vue&type=template&id=a21061c8&scoped=true"
import script from "./BitacoraManager.vue?vue&type=script&lang=js"
export * from "./BitacoraManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21061c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a21061c8')) {
      api.createRecord('a21061c8', component.options)
    } else {
      api.reload('a21061c8', component.options)
    }
    module.hot.accept("./BitacoraManager.vue?vue&type=template&id=a21061c8&scoped=true", function () {
      api.rerender('a21061c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/proposalProcess/components/Bitacora/BitacoraManager.vue"
export default component.exports